/*import axios from "axios";
import { ApiUrl } from "../utils/modules";
import { header } from "../utils/modules";

class UsersServices {
  getAll() {
    return axios.get(ApiUrl + "utilisateur");
  }
  
  getOne(id) {
    return axios.get(ApiUrl + `utilisateur/${id}`);
  }

  create(data) {
    return axios.post(ApiUrl + "utilisateur", data, header("json"));
  }

  update(id, data) {
    return axios.patch(ApiUrl + `utilisateur/${id}`, data, header("json"));
  }

  delete(id) {
    return axios.delete(ApiUrl + `utilisateur/${id}`);
  }
}

export default new UsersServices();*/

import axios from "axios";
import { ApiUrl, header } from "../../utils/modules";

class UsersServices {
  getAll() {
    return axios.get(`${ApiUrl}utilisateur`, {
      headers: header("json").headers,
    });
  }

  getOne(id) {
    return axios.get(`${ApiUrl}utilisateur/${id}`, {
      headers: header("json").headers,
    });
  }

  getOne(id) {
    return axios.get(`${ApiUrl}utilisateur/${id}`, {
      headers: header("json").headers,
    });
  }

  create(data) {
    return axios.post(`${ApiUrl}utilisateur`, data, {
      headers: header("json").headers,
    });
  }

  generateFile(data) {
    return axios.post(`${ApiUrl}utilisateur/generatefile`, data, {
      headers: header("json").headers,
    });
  }

  getSuperviseurByEntrepriseId(entrepriseId) {
    return axios.post(
      `${ApiUrl}utilisateur/utilisateurs-par-entreprise`,
      { entrepriseId: entrepriseId },
      { headers: header("json").headers }
    );
  }

  update(id, data) {
    return axios.put(`${ApiUrl}utilisateur/${id}`, data, {
      headers: header("json").headers,
    });
  }

  delete(id) {
    return axios.delete(`${ApiUrl}utilisateur/${id}`, {
      headers: header("json").headers,
    });
  }

  checkBuildStatus() {
    return axios.get(`${ApiUrl}build-status`, {
      headers: header("json").headers,
    });
  }

  getCaptures(data) {
    return axios.get(`${ApiUrl}utilisateur/${data.id}/${data.hour}`, {
      headers: header("json").headers,
    });
  }
  getCapturesClavier(data) {
    return axios.get(`${ApiUrl}historiqueClavier/${data.id}/${data.hour}`, {
      headers: header("json").headers,
    });
  }
  getCapturesNavigation(data) {
    return axios.get(`${ApiUrl}historiqueNavigation/${data.id}/${data.hour}`, {
      headers: header("json").headers,
    });
  }
  getCapturesInstallation(data) {
    return axios.get(`${ApiUrl}historiqueInstallation/${data.id}`, {
      headers: header("json").headers,
    });
  }
  updateManyUserAlerts(data) {
    return axios.patch(`${ApiUrl}utilisateur/alerts/configurer`, data, {
      headers: header("json").headers,
    });
  }

  removeUserAlert(data) {
    return axios.patch(`${ApiUrl}utilisateur/alerts/remove-user-alert`, data, {
      headers: header("json").headers,
    });
  }

  removeManyUserAlerts(data) {
    return axios.patch(`${ApiUrl}utilisateur/alerts/remove-many-alerts`, data, {
      headers: header("json").headers,
    });
  }

  updateNotifier(data) {
    return axios.patch(`${ApiUrl}utilisateur/alerts/update-notifier`, data, {
      headers: header("json").headers
    })
  }

  updateNotifierMany(data) {
    return axios.patch(`${ApiUrl}utilisateur/alerts/update-notifier-many`, data, {
      headers: header("json").headers
    })
  }

  updateEmailNotification(data) {
    return axios.patch(
      `${ApiUrl}utilisateur/alerts/update-email-notification`,
      data,
      { headers: header("json").headers }
    );
  }

  addNotifierEmail(data) {
    return axios.patch(
      `${ApiUrl}utilisateur/alerts/add-notifier-email`,
      data,
      { headers: header("json").headers }
    );
  }

  removeNotifierEmail(data) {
    return axios.patch(
      `${ApiUrl}utilisateur/alerts/remove-notifier-email`,
      data,
      { headers: header("json").headers }
    );
  }

  addEmailsMany(data) {
    return axios.patch(
      `${ApiUrl}utilisateur/alerts/add-emails-many`,
      data,
      { headers: header("json").headers }
    );
  }

  removeEmailsMany(data) {
    return axios.patch(
      `${ApiUrl}utilisateur/alerts/remove-emails-many`,
      data,
      { headers: header("json").headers }
    );
  }

  getTimeAlerts() {
    return axios.get(
      `${ApiUrl}alerts/time`,
      { headers: header("json").headers }
    )
  }

  updatePDP(id, file) {
    const formData = new FormData();
    formData.append("image", file);

    return axios.patch(`${ApiUrl}utilisateur/update/profil/${id}`, formData, {
      headers: {
        ...header("form-data").headers,
        "Content-Type": "multipart/form-data",
      },
    });
  }

  deleteImageFromServeur(imageUrl) {
    return axios.delete(`${ApiUrl}utilisateur/serveur/delete-image`, {
      headers: header("json").headers,
      data: { imageUrl },
    });
  }


  getHistoriqueByDateTime(clientId, dateHour) {
    return axios.get(`${ApiUrl}historiqueClavier/${clientId}/${dateHour}`, {
      headers: header("json").headers,
    });
  }
}


export default new UsersServices();
